import React from 'react';
import { ArrowRight, Download, Crosshair } from 'lucide-react';
import { FloatingAdinkra, KenteClothStrip } from '../components/Decorators';
import portrait from '../assets/images/adwoa-potrait.png';

const HomePage = () => (
  <div className="hero-container kente-hero-bg">
    <FloatingAdinkra count={6} color="rgba(201, 168, 76, 0.06)" />
    <div className="miracle-worker">
      Miracle Worker <Crosshair size={16} />
    </div>
    <div className="hero-content">
      <div>
        <h1 className="hero-title">Adwoa B. Acheampong</h1>
        <h2 className="hero-subtitle">Business Operations Architect & Growth Engineer</h2>
        <p className="hero-description">
          Tenacious innovator blending Ghanaian system insights with global data-driven strategies.
          I build scalable systems that turn visions into high-performing business —
          guided by Adinkra wisdom and unyielding grit.
        </p>
        <div style={{ display: 'flex', gap: '0.75rem', flexWrap: 'wrap' }}>
          <a href="#contact" className="btn-primary">Connect <ArrowRight size={14} /></a>
          <a href="/Adwoa B. Acheampong - Business Operations & EA (Resume).pdf" download className="btn-secondary btn-download">Resume <Download size={14} /></a>
          <a href="/Adwoa-Acheampong-1730042535173-Psychometric.pdf" download className="btn-secondary btn-download">Psychometric <Download size={14} /></a>
        </div>
      </div>
      <div className="hero-portrait-frame">
        <img src={portrait} alt="Adwoa B. Acheampong" className="hero-portrait" />
      </div>
    </div>
    <KenteClothStrip height={24} className="hero-kente" />
  </div>
);

export default HomePage;
